<template>
    <div
        class="upload-box"
        :class="{'deep-black': true}"
    >
        <div class="input-box">
            <el-input
                    class="search-box input theme-input"
                    v-model="newValue"
                    placeholder="搜索名称"
                    :clearable="true"
                    @focus="setSendKeyBoardToCocos({key: 'searchBox', value: false})"
                    @blur="setSendKeyBoardToCocos({key: 'searchBox', value: true})"
                    @keyup.native.enter="handleSearch"
                    prefix-icon="iconfont icon-fangdajing"
            />
            <!--<span-->
                <!--v-if="newValue"-->
                <!--class="cancel"-->
                <!--@click="$emit('cancel')"-->
            <!--&gt;取消</span>-->
        </div>
        <!--<button class="btn" @click="handleSearch">搜索</button>-->
        <div class="more-menu">
            <el-popover
                    placement="left"
                    width="508"
                    trigger="hover"
                    v-model="visible"
            >
                <Catalogs
                    v-if="catalogData"
                    :isShop.sync="isShop"
                    :data="catalogData"
                    :selectCatalog.sync="newSelectCatalog"
                    @onCatalogs="visible=false"
                />
                <!--<span-->
                    <!--slot="reference"-->
                    <!--class="img-box iconfont icon-caidan1"-->
                    <!--:class="{active: visible}"-->
                <!--&gt; </span>-->
            </el-popover>
            <!--<span class="title">{{typeName[type]}}</span>-->
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import Catalogs from './components/catalogs'
    export default {
        name: "search-box",
        components: {
            Catalogs
        },
        props: {
            value: String,
            type:String,
            catalogData: Array,
            selectCatalog: [String, Number],
            isShop: Boolean
        },
        computed: {
            typeName(){
                return {
                    template: '模版库',
                    scenes: '场景库',
                    image: '图片库',
                    audio: '音频库',
                    animation: '动画库',
                    video: '视频库',
                    tools: '工具库',
                    game: '游戏库',
                }
            }
        },
        watch:{
            value(vl){this.newValue = vl},
            newValue(vl){this.$emit('update:value',vl)},
            isShop(vl){this.newIsShop = vl},
            newIsShop(vl){this.$emit('update:isShop',vl)},
            selectCatalog(vl){this.newSelectCatalog = vl},
            newSelectCatalog(vl){this.$emit('update:selectCatalog',vl)},
        },
        data(){
            return {
                newIsShop: this.isShop,
                visible: false,
                newSelectCatalog: this.selectCatalog, // 目录选中
                newValue: this.value
            }
        },
        methods: {
            ...mapActions(['setSendKeyBoardToCocos']),
            handleSearch(){
                this.$emit('onSearchBox', this.newValue)
            },
            clear(){
                this.newValue = ''
            }
        }
    }
</script>
<style lang="scss" scoped>
.search-box /deep/ .el-input__inner::-webkit-input-placeholder { /* WebKit browsers */
    font-weight: 300;
}
.search-box /deep/ .el-input__inner{
    background: #F5F7FA;
    padding-left: 42px;
    border: none;
}
.search-box /deep/ .el-input__prefix{
    left: 14px;
    color: #606266;
}
.upload-box .input-box .search-box{
    background: #F5F7FA !important;
}
.upload-box{
    height:40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 20px 0px;
    position: relative;

    .input-box {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 20;

        .search-box {
            border-radius: 30px;
            border: none;
            outline: none;
            /*padding: 0px 10px;*/

            font-size: 14px;
            width: 147px;
            height: 40px;
            background: rgba(238, 238, 238, 1);
            border-radius: 4px;
            transition: width .2s linear;

            &.input {
                width: 220px;
                padding-right: 40px;
            }
        }
        .cancel {
            position: absolute;
            top: 10px;
            right: 16px;
            font-size:14px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:20px;
            cursor: pointer;
        }
    }
    .btn{
        font-size: 18px;
        width: 72px;
        height: 40px;
        background-color: #fed800;
        border-radius: 30px;
        border:none;
        margin-left: 8px;
        outline: none;
        cursor: pointer;

        &:active{
            opacity: .8;
        }
    }

    .more-menu{
        position: absolute;
        top: 6px;
        right: 0px;
        display: flex;
        flex-direction: row;
        align-items: center;
        z-index: 10;
        .img-box{
            font-size: 16px;
            margin-left: 8px;
            position: relative;
            top: 1px;
            cursor: pointer;
            transition: all .2s linear;
            outline: none;

            &.active{
                color: #e7622e;
            }
        }
        .title{
            font-size: 18px;
            margin-left: 12px;
            position: relative;
            top:1px;
        }
    }
}
</style>
